import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-child-info',
  templateUrl: './child-info.component.html',
  styleUrls: ['./child-info.component.scss']
})
export class ChildInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
